/**
 * Relatorio Automatico
 */
import {Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class RelatorioAutomatico extends Resource {
  idRelatorioAutomaticoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  pastaFTP: string | null = null
  senhaFTP: string | null = null

  periodoInicial: Date | null = null

  ativo: boolean = true

  get $id() {
    return this.idRelatorioAutomaticoPk
  }
  set $id(val) {
    this.idRelatorioAutomaticoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  reset() {
    this.idRelatorioAutomaticoPk = 0
    this.pastaFTP = null
    this.senhaFTP = null
    this.ativo = true
    this.periodoInicial = null
  }

  async getRelatorioAutomatico(id: number) {
    return await Request.get(`/admin/relatorio-automatico/${id}`)
      .name('getRelatorioAutomatico')
      .as(this)
      .getData()
  }

  async persistRelatorioAutomatico() {
    return await Request.post(`/admin/relatorio-automatico`, this)
      .name('persistRelatorioAutomatico')
      .asNumber()
      .getData()
  }
}
